import * as ReactComponentsRails from './src/react-components-rails';

export * from './src/react-components-rails';

export default ReactComponentsRails;
